import { CreateMeterReadingsRequest } from 'types/contracts'
import { Methods, PortalUserDataObject } from 'types/request'
import { getAxiosRequestConfig, newRequest } from 'utils/request'
import { store } from 'store/index.ts'
import { LANGUAGES } from '@boltenergy-be/shared'
import { getLowerCaseLanguage } from 'utils/language.ts'

/**
 * Creates meter readings
 *
 * @param {CreateMeterReadingsRequest} data
 * @returns {Promise<boolean>}
 */
export const saveMeterReadings = async (data: CreateMeterReadingsRequest): Promise<boolean> => {
  // Create user object
  const { contact, selected } = store.getState().contact

  const user = {
    email: contact?.email || '',
    firstName: contact?.firstName || '',
    language: getLowerCaseLanguage(contact?.language || LANGUAGES.NL),
    customerNumber: selected?.account
  } satisfies PortalUserDataObject

  const { contractNumber, ...rest } = data
  const { success } = await newRequest(
    getAxiosRequestConfig(Methods.POST, `/contracts/${contractNumber}/meter-readings`, { user, ...rest })
  )

  return success
}
